export const firebaseConfig = {
  apiKey: "AIzaSyCl_4N9bz5E6RT8gjOigQne5P9lygjyPM8",
  authDomain: "trea-cb887.firebaseapp.com",
  projectId: "trea-cb887",
  storageBucket: "trea-cb887.appspot.com",
  messagingSenderId: "755423967782",
  appId: "1:755423967782:web:44a0afdadfed721ff684e7"
};

export const FB_MESSSAGING_VAPID_KEY = 'BFxriyshEfkRqICeykp3tVvFQFjbzwmWL-gBmOagmL-cyz-CZEPPLmOHWN-JjjB8jwe25TW3MbRI06dPhbKdJ8Y';